<!-- <div class="occupants"> -->
<div class="occupants-header">
    <i class="hide-occupants fa fa-times"></i>
    <p class="occupants-heading">{{{o.label_occupants}}}</p>
</div>
<ul class="occupant-list"></ul>
<div class="chatroom-features"></div>
<!-- </div> -->
